import React, { createContext, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  let navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [progress, setProgress] = useState();
  const [currentId, setcurrentId] = useState(-1);
  const [fetchStatus, setFetchStatus] = useState(true);
  const [product, setProduct] = useState();
  const [img, setImg] = useState("");
  const [preview, setPreview] = useState("");
  const [inputProduct, setInputProduct] = useState({
    nama_produk: "",
    dimensi: "",
    daya: "",
    bahan: "",
    jenis_produk: "",
    fitur: "",
  });
  let images = [];

  const setConfig = () => {
    if (Cookies.get("token") === undefined) {
      return null;
    } else return Cookies.get("token");
  };
  const config = {
    headers: { "x-access-token": setConfig() },
  };

  const renderDataProduct = async () => {
    axios
      .get("https://productspec.cyclic.app/product", config)
      .then((res) => {
        const tempArr = res.data.map((el) => {
          return el;
        });
        setProduct(tempArr);
        return tempArr;
      })
      .catch((e) => alert(e.message));

    setFetchStatus(false);
  };

  const handleChangeInputProduk = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setInputProduct({ ...inputProduct, [name]: value });
  };

  const onImageChange = (e) => {
    for (let i = 0; i < e.target.files.length; i++) {
      images.push(URL.createObjectURL(e.target.files[i]));
    }
    // const image = e.target.files[0];
    setImg(e.target.files);
    setPreview(images);
  };

  const handleSubmitProduk = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    Object.values(img).forEach((el) => {
      formData.append("img", el);
    });
    const resp = await axios.post(
      "https://productspec.cyclic.app/product/",
      inputProduct
    );
    const uploadedImg = await axios.put(
      `https://productspec.cyclic.app/product/imgProduct/${resp.data.id}`,
      formData,
      {
        headers: {
          "Content-type": "multipart/form-data",
        },
        onUploadProgress: (data) => {
          //Set the progress value to show the progress bar

          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      }
    );
    const results = await Promise.all([resp, uploadedImg]);

    setcurrentId(-1);
    setInputProduct({
      nama_produk: "",
      dimensi: "",
      bahan: "",
      jenis_produk: "",
      fitur: "",
      daya: "",
    });
    setImg("");
    setProgress();
    setPreview("");
    if (preview != "") {
      setFetchStatus(true);
      navigate("/products");
    }
  };

  const handleEditProduct = (event) => {
    const id = event.target.value;
    navigate(`/products/edit_product/${id}`);
    setFetchStatus(true);
    // window.location.reload();
  };

  const contextState = {
    product,
    setProduct,
    fetchStatus,
    setFetchStatus,
    inputProduct,
    currentId,
    setcurrentId,
    setInputProduct,
    setIsLoggedIn,
    isLoggedIn,
    img,
    progress,
    setImg,
    preview,
    setPreview,
  };

  const contextFunctions = {
    renderDataProduct,
    onImageChange,
    handleChangeInputProduk,
    handleSubmitProduk,
    handleEditProduct,
  };

  return (
    <GlobalContext.Provider
      value={{
        contextState,
        contextFunctions,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
